import { memo as Memo } from 'react';

//* Components
import Text from '@components/global/Text';
import TableItem from '@components/global/TableItem';
import CustomLink from '@/components/global/CustomLink';

//* Styles
import TableContentStyle from './style';

const TableContent = Memo(({ data }) => {
	return (
		<TableContentStyle>
			<TableItem
				active
				title={data.bottomDescriptionTitle}
				description={data.bottomDescription}
			/>

			<div className={`otherInfoCont ${data.awards ? 'is-awards' : ''} ${data.awards ? 'is-team' : ''} ${data.visitWebsiteUrl ? 'is-url' : ''}`}>
				<div className={'otherInfo'}>
					{data.awards?.length > 0 ? (
						<div className={'otherInfoItem'}>
							<Text
								text={'awards'}
								className={`title p-m font-anonymous font-bold`}
							/>

							<div className={`description`}>
								{data.awards.map((i, k) => {
									return (
										<p
											key={k}
											className={`p-m font-poppins font-light line-txt`}>
											{i}
										</p>
									);
								})}
							</div>
						</div>
					) : null}

					{data.team?.length > 0 ? (
						<div className={'otherInfoItem'}>
							<Text
								text={'team'}
								className={`team-title p-m font-anonymous font-bold`}
							/>

							<div className={`team-description`}>
								{data.team.map((i, k) => {
									return (
										<p
											key={k}
											className={`p-m font-poppins font-light line-txt`}>
											{i}
										</p>
									);
								})}
							</div>
						</div>
					) : null}
				</div>

				{data.visitWebsiteUrl ? (
					<div className={'linkCont'}>
						<CustomLink
							external
							className='crCircle'
							url={data.visitWebsiteUrl}>
							<Text
								text={'visitTheWebsite'}
								className={`p-m font-poppins font-medium font-italic font-underline`}
							/>
						</CustomLink>
					</div>
				) : null}
			</div>
		</TableContentStyle>
	);
});

export default TableContent;
